/**
 * PowerFlush — animated SVG showing bi-directional high-velocity flushing
 * removing magnetite particles from a heating system.
 */

export function PowerFlush() {
  return (
    <figure style={{ margin: 0 }}>
      <svg viewBox="0 0 480 200" width="100%" role="img" aria-label="Power flush animation">
        <title>Bi-directional high-velocity power flushing</title>
        <defs>
          <style>{`
            .pf-pipe { fill: #e2e8f0; stroke: #475569; stroke-width: 2; }
            .pf-flow-fwd { stroke: #3b82f6; stroke-width: 2.5; fill: none; stroke-dasharray: 10,6; animation: pf-fwd 0.6s linear infinite; }
            .pf-flow-rev { stroke: #f59e0b; stroke-width: 2.5; fill: none; stroke-dasharray: 10,6; animation: pf-rev 0.6s linear infinite; }
            .pf-sludge { fill: #1e293b; opacity: 0.7; }
            .pf-sludge-moving { fill: #1e293b; opacity: 0.5; animation: pf-move 1.5s ease-in-out infinite alternate; }
            .pf-label { font-family: system-ui, sans-serif; font-size: 11px; fill: #475569; text-anchor: middle; }
            .pf-heading { font-family: system-ui, sans-serif; font-size: 12px; fill: #1e293b; font-weight: 600; text-anchor: middle; }
            .pf-machine { fill: #dbeafe; stroke: #2563eb; stroke-width: 2; }
            @keyframes pf-fwd { to { stroke-dashoffset: -16; } }
            @keyframes pf-rev { to { stroke-dashoffset: 16; } }
            @keyframes pf-move { 0% { transform: translateX(0); } 100% { transform: translateX(30px); } }
          `}</style>
        </defs>

        {/* Power flush machine */}
        <rect x="30" y="60" width="70" height="50" rx="8" className="pf-machine" />
        <text x="65" y="82" className="pf-heading" style={{ fontSize: '10px' }}>Flush</text>
        <text x="65" y="96" className="pf-heading" style={{ fontSize: '10px' }}>unit</text>

        {/* Main pipe run */}
        <rect x="100" y="75" width="280" height="20" rx="10" className="pf-pipe" />

        {/* Forward flow (top) */}
        <line x1="110" y1="82" x2="370" y2="82" className="pf-flow-fwd" />

        {/* Reverse flow (bottom) */}
        <line x1="370" y1="88" x2="110" y2="88" className="pf-flow-rev" />

        {/* Sludge particles being dislodged */}
        <circle cx="180" cy="85" r="3" className="pf-sludge-moving" />
        <circle cx="220" cy="85" r="4" className="pf-sludge-moving" style={{ animationDelay: '0.3s' }} />
        <circle cx="270" cy="85" r="3" className="pf-sludge-moving" style={{ animationDelay: '0.6s' }} />
        <circle cx="310" cy="85" r="2.5" className="pf-sludge-moving" style={{ animationDelay: '0.9s' }} />
        <circle cx="340" cy="85" r="3.5" className="pf-sludge-moving" style={{ animationDelay: '0.4s' }} />

        {/* Radiator */}
        <rect x="390" y="55" width="60" height="60" rx="4" fill="#f1f5f9" stroke="#64748b" strokeWidth="1.5" />
        {/* Radiator fins */}
        <line x1="400" y1="60" x2="400" y2="110" stroke="#cbd5e1" strokeWidth="1.5" />
        <line x1="410" y1="60" x2="410" y2="110" stroke="#cbd5e1" strokeWidth="1.5" />
        <line x1="420" y1="60" x2="420" y2="110" stroke="#cbd5e1" strokeWidth="1.5" />
        <line x1="430" y1="60" x2="430" y2="110" stroke="#cbd5e1" strokeWidth="1.5" />
        <line x1="440" y1="60" x2="440" y2="110" stroke="#cbd5e1" strokeWidth="1.5" />

        {/* Static sludge in radiator bottom */}
        <ellipse cx="420" cy="105" rx="18" ry="5" className="pf-sludge" />

        {/* Arrows showing bi-directional */}
        <polygon points="105,70 115,75 105,80" fill="#3b82f6" opacity="0.8" />
        <polygon points="375,90 365,85 375,80" fill="#f59e0b" opacity="0.8" />

        {/* Labels */}
        <text x="240" y="55" className="pf-heading">High-velocity bi-directional flush</text>
        <text x="240" y="130" className="pf-label">Direction reverses to dislodge magnetite from all surfaces</text>

        {/* Legend */}
        <line x1="100" y1="160" x2="130" y2="160" className="pf-flow-fwd" />
        <text x="170" y="164" className="pf-label">Forward flow</text>
        <line x1="240" y1="160" x2="270" y2="160" className="pf-flow-rev" />
        <text x="310" y="164" className="pf-label">Reverse flow</text>
        <circle cx="370" cy="160" r="4" className="pf-sludge" />
        <text x="410" y="164" className="pf-label">Magnetite</text>
      </svg>
    </figure>
  );
}
